import script from "./MngAppointmentRecordTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./MngAppointmentRecordTableRow.vue?vue&type=script&lang=ts&setup=true"

import "./MngAppointmentRecordTableRow.vue?vue&type=style&index=0&id=126a338f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-126a338f"]])

export default __exports__